import { render, staticRenderFns } from "./EditBuildingInformation.vue?vue&type=template&id=08672506&"
import script from "./EditBuildingInformation.vue?vue&type=script&lang=js&"
export * from "./EditBuildingInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports